import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { NotaFiscalServicoModel } from '../../models/notaFiscalServico.model';
import { NotaFiscalService } from '../../services/nota-fiscal-servico.service';
import { SpinnerService } from '../../services/spinner.service'
import { ToastService } from '../../services/toast.service';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum'
import * as ExcelJS from 'exceljs';
import { FormatadorHelper } from '../../helpers/formatador.helper';
import { Icones } from '../../shared/variaveisDeRotas';
import { JwtHelper } from '../../helpers/jwtDecode.helper';
import { retornaDescricao } from '../../shared/mock/descricao';

@Component({
  selector: 'app-faturamento',
  templateUrl: './faturamento.component.html',
  styleUrls: ['./faturamento.component.scss'],
})
export class FaturamentoComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  @ViewChild('dt') dt: Table | undefined;

  faturamentos: NotaFiscalServicoModel[] = [];
  faturamentosFiltrados: NotaFiscalServicoModel[] = [];
  dataInicio: Date | null = null;
  dataFim: Date | null = null;
  loading: boolean = false;

  get faturamentosComPropriedadesOrdenacao() {
    return this.faturamentosFiltrados.map(faturamento => ({
      ...faturamento,
      dataEmissao: this.converterDataBrParaDate(faturamento.dataEmissao),
      cnpjCpfTomador: this.formatarCpfCnpj(faturamento.tomador.cnpj ? faturamento.tomador.cnpj : faturamento.tomador.cpf),
      nomeTomador: faturamento.tomador.razao_social,
      numeroNfse: faturamento.createNfseResponse.codigo,
      codigoServico: this.formatarCodigoServico(faturamento.servico.item_lista_servico),
      descricaoCodigoServico: faturamento.servico.discriminacao,
      valor: faturamento.servico.valor_servicos
    }));
  }

  constructor(
    private notaFiscalService: NotaFiscalService,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private jwtHelper: JwtHelper
  ) { }

  ngOnInit() {
    this.tituloChange.emit('Faturamentos');
    this.iconeChange.emit(Icones.listaTopicoAmarelo);
    this.tituloDescricao.emit(retornaDescricao('faturamento').titulo);
    this.textoDescricao.emit(retornaDescricao('faturamento').texto);
    this.mostrarDescricao.emit(true)

    this.listarNotasFiscais();
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }

  listarNotasFiscais() {
    this.loading = true;
    this.spinnerService.show('Carregando Faturamentos...');

    const usuarioId = this.jwtHelper.getUserIdFromToken();

    this.notaFiscalService.listaNotasFiscaisServico(usuarioId).subscribe({
      next: (data) => {
        this.faturamentos = data.filter(faturamento =>
          faturamento.createNfseResponse.status === 'autorizado' && (faturamento.ambiente === "producao" || faturamento.ambiente == null)
        );
        this.ordenarPorDataEmissao();
        
        this.faturamentosFiltrados = this.faturamentos;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.toastService.setMensagemToast('Falha ao carregar notas fiscais.', SeveridadeToast.Error);
        console.error('Erro ao carregar faturamentos:', error);
      },
      complete: () => {
        this.spinnerService.hide();
      }
    });
  }

  converterDataBrParaDate(data: string | Date): Date {
    if (!data) return new Date('');

    if (data instanceof Date) {
      return data;
    }

    if (typeof data === 'string' && data.includes('-')) {
      return new Date(data);
    }

    if (typeof data === 'string' && data.includes('/')) {
      const partes = data.split('/');
      
      if (partes.length === 3) {
        const dia = parseInt(partes[0], 10);
        const mes = parseInt(partes[1], 10);
        const ano = parseInt(partes[2], 10);
        
        if (dia >= 1 && dia <= 31 && mes >= 1 && mes <= 12 && ano >= 1900) {
          
          return new Date(ano, mes - 1, dia);
        }
      }
    }

    const date = new Date(data);
    return isNaN(date.getTime()) ? new Date('') : date;
  }

  formatarDataExibicao(data: string | Date): string {
    if (!data) return '';

    try {
      let dataConvertida: Date;

      if (data instanceof Date) {
        dataConvertida = data;
      } else {

        if (typeof data === 'string') {
      
          if (data.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            const [dia, mes, ano] = data.split('/').map(Number);
            dataConvertida = new Date(ano, mes - 1, dia);
          } else {
            dataConvertida = this.converterDataBrParaDate(data);
          }
        } else {
          dataConvertida = this.converterDataBrParaDate(data);
        }
      }
      
      if (isNaN(dataConvertida.getTime())) {
        return 'Data inválida';
      }

      const dia = dataConvertida.getDate().toString().padStart(2, '0');
      const mes = (dataConvertida.getMonth() + 1).toString().padStart(2, '0');
      const ano = dataConvertida.getFullYear();

      return `${dia}/${mes}/${ano}`;
    } catch (error) {
      console.error('Erro ao formatar data:', error, data);
      return 'Data inválida';
    }
  }

  filtrarPorData() {
    if (this.dataInicio && this.dataFim) {

      const inicio = new Date(this.dataInicio.getFullYear(), this.dataInicio.getMonth(), 1);
      inicio.setUTCHours(0, 0, 0, 0);


      const fim = new Date(this.dataFim.getFullYear(), this.dataFim.getMonth() + 1, 0);
      fim.setUTCHours(23, 59, 59, 999);

      this.faturamentosFiltrados = this.faturamentos.filter(faturamento => {
        const dataEmissaoConvertida = this.converterDataBrParaDate(faturamento.dataEmissao);

        return dataEmissaoConvertida >= inicio && dataEmissaoConvertida <= fim;
      });
      this.ordenarDadosFiltrados();
    } else {
      this.faturamentosFiltrados = this.faturamentos;
    }
  }

  ordenarPorDataEmissao() {
    this.faturamentos.sort((a, b) => {
      const dataA = this.converterDataBrParaDate(a.dataEmissao);
      const dataB = this.converterDataBrParaDate(b.dataEmissao);
      return dataB.getTime() - dataA.getTime();
    });
  }

  ordenarDadosFiltrados() {
    this.faturamentosFiltrados.sort((a, b) => {
      const dataA = this.converterDataBrParaDate(a.dataEmissao);
      const dataB = this.converterDataBrParaDate(b.dataEmissao);
      return dataB.getTime() - dataA.getTime();
    });
  }

  applyFilterGlobal(value: string): void {
    if (this.dt) {
      this.dt.filterGlobal(value, 'contains');
    }
  }

  downloadExcel() {
    this.spinnerService.show('Gerando relatório Excel...');
  
 
    let dadosParaExportar = this.dt?.filteredValue || this.faturamentosComPropriedadesOrdenacao;

    if (this.dt && this.dt.value) {
      dadosParaExportar = [...this.dt.value];
    }
    
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Faturamentos');

    const tituloRow = worksheet.addRow(['NFSe Emitidas']);
    tituloRow.font = { bold: true, underline: true };
    worksheet.mergeCells(`A${tituloRow.number}:F${tituloRow.number}`);
    tituloRow.alignment = { vertical: 'middle', horizontal: 'center' };

    const cnpjTomador = dadosParaExportar.length > 0 ? dadosParaExportar[0].prestador?.cnpj || 'CNPJ não encontrado' : 'CNPJ não encontrado';
 
    let dataInicioTexto = 'Nenhuma Data Selecionada';
    let dataFimTexto = 'Nenhuma Data Selecionada';
    
    if (this.dataInicio && this.dataFim) {
      const primeiroDiaInicio = new Date(this.dataInicio.getFullYear(), this.dataInicio.getMonth(), 1);
      dataInicioTexto = primeiroDiaInicio.toLocaleDateString('pt-BR');

      const ultimoDiaFim = new Date(this.dataFim.getFullYear(), this.dataFim.getMonth() + 1, 0);
      dataFimTexto = ultimoDiaFim.toLocaleDateString('pt-BR');
    }

    const cnpjRow = worksheet.addRow(['CNPJ:', cnpjTomador]);
    const inicioRow = worksheet.addRow(['Período Início:', dataInicioTexto]);
    const fimRow = worksheet.addRow(['Período Fim:', dataFimTexto]);

    [cnpjRow, inicioRow, fimRow].forEach(row => {
      row.getCell(1).font = { bold: true };
    });

    const dadosOriginais = this.faturamentosComPropriedadesOrdenacao;
    const dadosFiltrados = this.dt?.filteredValue;
    
    if (dadosFiltrados && dadosFiltrados.length !== dadosOriginais.length) {
      const filtroRow = worksheet.addRow(['Filtro de Pesquisa:', 'Aplicado']);
      filtroRow.getCell(1).font = { bold: true };
      const registrosRow = worksheet.addRow(['Registros Exportados:', `${dadosParaExportar.length} de ${dadosOriginais.length}`]);
      registrosRow.getCell(1).font = { bold: true };
    }

    worksheet.addRow([]);

    const titleRow = worksheet.addRow([
      'Data de Emissão',
      'CNPJ/CPF do Tomador',
      'Nome do Tomador',
      'Número da NFS-e',
      'Código Serviço',
      'Descrição Código de Serviço',
      'Valor'
    ]);

    titleRow.font = { bold: true };
    titleRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD3D3D3' },
    };

    worksheet.columns = [
      { key: 'dataEmissao', width: 20 },
      { key: 'cnpjCpfTomador', width: 45 },
      { key: 'nomeTomador', width: 45 },
      { key: 'numeroNfse', width: 20 },
      { key: 'codigoServico', width: 20 },
      { key: 'descricaoCodigoServico', width: 45 },
      { key: 'valor', width: 15 },
    ];

    dadosParaExportar.forEach((item, index) => {
      const dataEmissaoFormatada = this.formatarDataExibicao(item.dataEmissao);
      const row = worksheet.addRow({
        dataEmissao: dataEmissaoFormatada,
        cnpjCpfTomador: item.cnpjCpfTomador,
        nomeTomador: item.nomeTomador,
        numeroNfse: item.numeroNfse,
        codigoServico: item.codigoServico,
        descricaoCodigoServico: item.descricaoCodigoServico,
        valor: Number(item.valor) || 0,
      });

      row.getCell(7).numFmt = '#,##0.00'; 
    });



    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      
      const dataHora = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
      a.download = `Relatório-Faturamentos-${dataHora}.xlsx`;
      
      a.click();
      window.URL.revokeObjectURL(url);
      this.toastService.setMensagemToast('Download da planilha concluído!', SeveridadeToast.Success);
      this.spinnerService.hide();
    }).catch((error) => {
      console.error('Erro ao gerar Excel:', error);
      this.toastService.setMensagemToast('Erro ao gerar relatório Excel.', SeveridadeToast.Error);
      this.spinnerService.hide();
    });
  }

  formatarCpfCnpj(cpfCnpj: string | null | undefined): string {
    if (!cpfCnpj) {
      return 'Exterior';
    }
    return FormatadorHelper.formatarCpfCnpj(cpfCnpj);
  }

  formatarCodigoServico(codigoServico: string): string {
    if (codigoServico.length === 6) {
      return `${codigoServico.substring(0, 2)}.${codigoServico.substring(2, 4)}.${codigoServico.substring(4, 6)}`;
    }
    return codigoServico;
  }
}
